import { ref } from 'vue'
import api, { getStoredAdmin } from '@/services/api'

export const schoolManagementEnabled = ref(false)
let actor = null, pending = null, pendingActor = null, generation = 0, loadedAt = 0
export async function loadAdminCapabilities(force = false) {
  const id = getStoredAdmin()?.id
  if (!id) { actor = null; generation++; schoolManagementEnabled.value = false; return false }
  if (!force && actor === id && Date.now() - loadedAt < 30000) return schoolManagementEnabled.value
  if (!force && pending && pendingActor === id) return pending
  const ticket = ++generation
  schoolManagementEnabled.value = false
  const work = (async () => {
    try {
      const result = await api.get('/capabilities')
      if (ticket === generation && getStoredAdmin()?.id === id) { schoolManagementEnabled.value = result.data?.data?.school_management === true; actor = id; loadedAt = Date.now() }
    } catch { if (ticket === generation) { actor = null; schoolManagementEnabled.value = false } }
    return schoolManagementEnabled.value
  })()
  pending = work
  pendingActor = id
  try { return await work } finally { if (pending === work) { pending = null; pendingActor = null } }
}
